export default __webpack_public_path__ + "static/watsonlaird-logo-white-da9c470ae759ac479443374bf85afd56.svg";